import dayjs from 'dayjs'
import {
  GTOB_TOKEN_EXPIRATION_IDENTIFIER,
  GTOB_TOKEN_IDENTIFIER,
  GTOB_TOKEN_LONG_EXPIRATION_IDENTIFIER,
  GTOB_URL,
} from '../constants'

export const formatDate = (stringDate: string, format = 'DD-MM-YYYY') =>
  dayjs(stringDate).format(format).toString()

export const createDateFromString = (stringDate: string) => dayjs(stringDate)

export const getDaysAgoFromADate = (stringDate: string) => dayjs().diff(dayjs(stringDate), 'days')

/**
 *
 * @param array -> Any array of any type
 * @returns -> A boolean that indicates if the array only contains string elements
 */
export const isArrayOfStrings = (array: unknown[]) =>
  array.every((arrayItem) => typeof arrayItem === 'string')

export const navigateToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

export const applyMaskValue = (inputValue: string, mask?: string) => {
  let i = 0

  const result = mask?.split('').reduce((current: string, next: string) => {
    if (i >= inputValue.length) return current

    if (next === '9' || next === 'X') {
      current += inputValue[i]
      i += 1
    } else {
      current += next
    }

    return current
  }, '')

  return result
}

/**
 * Revoke OAuth tokens on the server and redirect away from the app.
 * Passes access/refresh tokens to WordPress so stale refresh tokens cannot be reused.
 */
export const revokeOAuthSessionAndLogout = (
  postLogoutRedirectUri: string = GTOB_URL
) => {
  const stringToken = localStorage.getItem(GTOB_TOKEN_IDENTIFIER)

  localStorage.removeItem(GTOB_TOKEN_IDENTIFIER)
  localStorage.removeItem(GTOB_TOKEN_EXPIRATION_IDENTIFIER)
  localStorage.removeItem(GTOB_TOKEN_LONG_EXPIRATION_IDENTIFIER)

  const params = new URLSearchParams({
    post_logout_redirect_uri: postLogoutRedirectUri,
  })

  if (stringToken) {
    try {
      const token = JSON.parse(stringToken) as {
        access_token?: string
        refresh_token?: string
      }
      if (token.access_token) {
        params.set('access_token', token.access_token)
      }
      if (token.refresh_token) {
        params.set('refresh_token', token.refresh_token)
      }
    } catch {
      // Ignore malformed token data; still clear local session below
    }
  }

  window.location.replace(
    `https://login.goodtobook.com/oauth/destroy?${params.toString()}`
  )
}

/** @deprecated Use revokeOAuthSessionAndLogout */
export const logout = revokeOAuthSessionAndLogout

